var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import styled from "styled-components";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import { StyledButton } from "../styleComponents";
var SubmitButton = styled(StyledButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 2rem 0 0;\n"], ["\n  margin: 2rem 0 0;\n"])));

var PeerReviewSubmitButton = function PeerReviewSubmitButton(props) {
  var themeProvider = React.useContext(ThemeProviderContext);
  var ThemedButton = themeProvider.peerReviewSubmitButton;

  if (ThemedButton) {
    return React.createElement(ThemedButton, __assign({}, props));
  }

  return React.createElement(SubmitButton, {
    variant: "contained",
    color: "primary",
    disabled: props.disabled,
    onClick: props.onClick
  }, props.children);
};

export default PeerReviewSubmitButton;
var templateObject_1;